import {AppAction} from "../actions/appActions";
import {ISabitler} from "../../constants/types/logbook";


interface AppState {
	sabitler?: ISabitler;
}

const initialState: AppState = {
	sabitler: undefined,
};

const authReducer = (state = initialState, action: AppAction): AppState => {
	switch (action.type) {
		case 'SABITLER_KAYDET':
			return {...state, sabitler: action.payload};
		default:
			return state;
	}
};

export default authReducer;